import { render, staticRenderFns } from "./WalletPaymentRequest.vue?vue&type=template&id=a6fd4a12"
import script from "./WalletPaymentRequest.vue?vue&type=script&lang=js"
export * from "./WalletPaymentRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports